const defaultSlide = {
  title: 'Untitled',
  desktopOnly: false,
  mobileOnly: false,
  displayOrder: 0,
  layout: {
    enabled: 'on',
    device: 'both',
    gridGap: '0',
    numberOfColumns: 9,
    numberOfRows: 9,
    caption: {
      position: {
        left: '10%',
        right: '10%',
        top: '10%',
        bottom: '10%',
        alignSelf: 'center',
        justifySelf: 'center'
      },
    },
    columns: [
      {
        title: 'Column 1',
        columnStart: 1,
        rowStart: 1,
        rowEnd: 1,
        columnEnd: 1,
        width: 'auto',
        height: 'auto',
        vAlign: 'center',
        hAlign: 'center',
        photo: {
          path: '',
          url: ''
        },
        imagePosition: 'Center',
        imageAppearance: 'Contain'
      }
    ]
  }
};

export default defaultSlide;



// WEBPACK FOOTER //
// ./src/containers/add/defaultSlide.js